import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL HELPERS
import useRecordView from 'helpers/getRecordView';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';
import Record from 'parts/record/Record';

// MAIN COMPONENT
const LenderUpdate = () => {

  // CONTEXT
  const { isAdd } = useRecordView();

  // RENDER
  return (
    <Record.Update
      title={`${isAdd ? 'Add' : 'Edit'} AM/Finance Lender`}
      recordLabel="AM/Finance lender"
      endpoints={ENDPOINTS.admin.amFinance.lenders}
      initialValues={{
        is_active: 1
      }}
    >
      <Card body={<FormBody />} />
    </Record.Update>
  );
};

const FormBody = () => (
  <Form.Body>
    <Form.YesNo
      name='is_active'
      label='Active'
      required
    />
    <Form.Control
      name='lender_name'
      label='Lender Name'
      required
    />
    <Record.Log />
  </Form.Body>
)

// EXPORT
export default LenderUpdate;
